import React, { useState } from "react"
import Input from "./Input"
import PropTypes from "prop-types"
import Button from "./Button"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUndo } from "@fortawesome/free-solid-svg-icons"

function InputSubmit({
  handleSubmission,
  defaultValue,
  length,
  type,
  buttonName = "submit",
  inline = false,
}) {
  const [text, setText] = useState(defaultValue)

  const handleChange = (event) => {
    setText(event.target.value)
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    handleSubmission(text)
  }

  const reset = () => {
    setText(defaultValue)
  }

  return (
    <>
      <Input
        type={type}
        length={length}
        value={text || ""}
        onChange={handleChange}
        inline={inline}
      />
      {text != defaultValue && (
        <>
          <span> </span>
          <Button onClick={handleSubmit}>{buttonName}</Button>
          <Button onClick={reset}>
            <FontAwesomeIcon icon={faUndo} />
          </Button>
        </>
      )}
    </>
  )
}

InputSubmit.propTypes = {
  handleSubmission: PropTypes.func,
  defaultValue: PropTypes.any,
  type: PropTypes.any,
  length: PropTypes.number,
  buttonName: PropTypes.string,
  inline: PropTypes.bool,
}
export default InputSubmit
